module.exports = __webpack_public_path__ + "img/business_plan.557714ca.png";